import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { baseURL, getUserProfile } from "../redux/Action";
import { GrMail } from "react-icons/gr";
import { HiLocationMarker } from "react-icons/hi";
import AddAddress from "../Components/AddAddress";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Profile = () => {
  const { isAuth, profile, token } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [address, setAddress] = useState(false);
  const [data, setData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      address: data,
    };
    const toastId = toast.loading("UPDATING ARCHIVE...", { theme: "light" });
    axios
      .put(`${baseURL}/users/user/edit`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "ARCHIVE UPDATED",
          type: "success",
          isLoading: false,
          theme: "light",
          autoClose: 2000,
          closeOnClick: true,
        });
        getUserProfile(dispatch);
        setAddress(false);
      })
      .catch((err) => {
        toast.update(toastId, {
          render: "UPDATE FAILED",
          type: "error",
          isLoading: false,
          theme: "light",
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };

  useEffect(() => {
    document.title = "Blogshog | Profile";
    getUserProfile(dispatch);
  }, [dispatch]);

  if (!isAuth) {
    return <Navigate to="/login"></Navigate>;
  }

  return (
    <div className="min-h-screen bg-transparent dark:bg-transparent text-black dark:text-white py-20 px-4 sm:px-6 lg:px-8 flex items-start justify-center font-sans mt-[60px]">
      <div className="w-full max-w-4xl">
        <div className="bg-white dark:bg-[#0a0a0a] border-4 border-black dark:border-white/30 shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] dark:shadow-[12px_12px_0px_0px_rgba(255,255,255,0.5)] relative">
          <div className="absolute top-0 right-0 bg-black dark:bg-white text-white dark:text-black px-3 py-1 text-[10px] font-mono tracking-widest border-l border-b border-black dark:border-white/30 uppercase z-10 font-bold shadow-[-2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[-2px_2px_0px_0px_rgba(255,255,255,0.5)] hidden md:block">
            USER DIRECTORY SECTION 01
          </div>

          <div className="h-40 sm:h-56 w-full bg-gray-200 dark:bg-[#111] flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 pattern-boxes pattern-white dark:pattern-gray-500 pattern-bg-black dark:pattern-bg-[#111] pattern-size-8 opacity-20"></div>
            <span className="text-white/40 dark:text-white/10 font-black text-6xl sm:text-8xl tracking-tighter uppercase whitespace-nowrap absolute select-none">
              PERSONAL INFO PERSONAL INFO
            </span>
          </div>

          <div className="px-6 sm:px-12 pb-12">
            {profile.map((p) => (
              <div
                key={p._id}
                className="relative flex flex-col items-center sm:items-start sm:flex-row gap-8 sm:gap-12 -mt-20 sm:-mt-24 z-20"
              >
                <div className="relative isolate group">
                  <div className="absolute inset-0 bg-black dark:bg-white rotate-[-4deg] scale-[1.05] transition-transform group-hover:rotate-0 -z-10 shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] dark:shadow-[6px_6px_0px_0px_rgba(255,255,255,0.5)]"></div>
                  <img
                    className="w-40 h-40 sm:w-48 sm:h-48 object-cover border-4 border-black dark:border-white/30 bg-white dark:bg-black grayscale group-hover:grayscale-0 transition-all duration-300"
                    src={p.avatar}
                    alt="Profile"
                  />
                </div>

                <div className="flex-1 mt-4 sm:mt-28 text-center sm:text-left space-y-6">
                  <div>
                    <h2 className="text-[10px] font-mono uppercase tracking-widest text-black/60 dark:text-gray-400 font-bold mb-1">
                      IDENTIFIER
                    </h2>
                    <h1 className="text-4xl sm:text-6xl font-black text-black dark:text-white uppercase tracking-tighter leading-none border-b-4 border-black dark:border-white/30 pb-4 inline-block break-all sm:break-normal">
                      {p.name}
                    </h1>
                  </div>

                  <div className="flex flex-col xl:flex-row gap-6 sm:gap-8 items-center sm:items-start text-sm font-bold text-black dark:text-white font-mono uppercase tracking-widest">
                    <div className="flex flex-col gap-1 items-center sm:items-start">
                      <span className="text-[10px] text-gray-500 dark:text-gray-400">
                        CONTACT
                      </span>
                      <p className="flex items-center gap-2 border border-black dark:border-white/30 bg-[#f4f4f4] dark:bg-black px-4 py-2 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
                        <GrMail className="text-black dark:text-white text-base" />
                        <span className="truncate max-w-[200px] sm:max-w-none">
                          {p.email}
                        </span>
                      </p>
                    </div>

                    <div className="flex flex-col gap-1 items-center sm:items-start">
                      <span className="text-[10px] text-gray-500 dark:text-gray-400">
                        LOCATION
                      </span>
                      <div className="flex items-center gap-2 border border-black dark:border-white/30 bg-[#f4f4f4] dark:bg-black px-4 py-2 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
                        <HiLocationMarker className="text-black dark:text-white text-base" />
                        {p.addresses?.length > 0 ? (
                          <span>
                            {p.addresses[0].city}, {p.addresses[0].state}
                          </span>
                        ) : (
                          <div className="flex items-center gap-4">
                            <span>UNDISCLOSED</span>
                            <button
                              className="text-white dark:text-black bg-black dark:bg-white hover:bg-gray-800 dark:hover:bg-gray-200 px-3 py-1 text-[10px] border border-black dark:border-white/30 transition-colors cursor-pointer disabled:opacity-50"
                              onClick={() => setAddress(!address)}
                            >
                              ASSIGN COORDS
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {address && (
            <div className="px-6 sm:px-12 pb-12 border-t-4 border-black dark:border-white/30 pt-10 bg-[#f4f4f4] dark:bg-[#111]">
              <h3 className="text-2xl font-black text-black dark:text-white uppercase tracking-tighter mb-8">
                REGISTER NEW COORDINATES
              </h3>
              <AddAddress
                handleChange={handleChange}
                handleSubmit={handleSubmit}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
